import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import i18next from 'v2/helpers/i18n';
import Title, { titleStyle } from './Title';
import Signature from './Signature';

const Docusign = ({ useSignature, status, docType }) => {
  const isLoi = docType === 'loi';

  return (
    <Box pl={2} pr={2} pb={2} data-testid="document-creator-signature-section">
      <Paper>
        <Title text={isLoi ? i18next.t('loi-signature') : 'Order signature'} />
        {!isLoi && (
          <>
            <Typography {...titleStyle} fontWeight={400} fontSize={16}>
              Choose how you want to proceed with document signing by selecting an
              option from the dropdown menu below.
            </Typography>
            <Signature useSignature={useSignature} status={status} />
          </>
        )}
      </Paper>
    </Box>
  );
};

export default Docusign;
